export const convertForRichTextFeature = (text: string): Content.RichText['content'] => {
	const richTextContent = {
		properties: {
			content: {
				markup: text,
			},
		},
	};
	return richTextContent;
};
